import { Header, Footer } from '@/shared/components/layout';
import { useDocumentTitle } from '@/shared/hooks';

const TermsPage = () => {
  useDocumentTitle('Terms of Service - BrokerMax');
  return (
    <div className="min-h-screen">
      <Header variant="light-hero" />
      <main>
        {/* TERMS PAGE */}
        <section
          id="terms-page"
          className="gr--whitesmoke pb--80 xl:!pb-[80px] lg:max-xl:!pb-[60px] md:max-lg:!pb-[50px] inner-page-hero division pt-[180px] lg:max-xl:pt-[160px] md:max-lg:!mt-[80px] md:max-lg:pt-[70px]"
        >
          <div className="container">
            <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] justify-center">
              <div className="xl:w-10/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
                {/* INNER PAGE TITLE */}
                <div className="inner-page-title !text-center xl:!mb-[80px] lg:max-xl:!mb-[60px] md:max-lg:!mb-[45px] sm:max-md:!mb-[50px] xsm:max-sm:!mb-[50px]">
                  <h2 className="s-52 w--700 xl:!text-[3.25rem] lg:max-xl:!text-[3rem] md:max-lg:!text-[2.79411rem] sm:max-md:!text-[2.375rem] xsm:max-sm:!text-[2.0625rem] !font-bold !mb-0 md:max-lg:!mb-0 sm:max-md:!mb-0 xsm:max-sm:!mb-0 leading-[1.25] font-Jakarta sm:max-md:!leading-[1.35] xsm:max-sm:!leading-[1.35]">
                    Terms of Service
                  </h2>
                  <p className="p-lg xl:!text-[1.1875rem] leading-none xl:!mt-[20px] !mb-0 lg:max-xl:!text-[1.15rem] lg:max-xl:!mt-[18px] md:max-lg:!text-[1.15rem] md:max-lg:!mt-[14px] sm:max-md:!text-[1.15rem] sm:max-md:!mt-[10px] xsm:max-sm:!text-[1.15rem] xsm:max-sm:!leading-[1.6666] xsm:max-sm:!mt-[10px] xsm:max-sm:px-[5%] xsm:max-sm:py-0">
                    This policy is effective as of 23th October 2022
                  </p>
                </div>
                {/* TEXT BLOCK */}
                <div className="txt-block legal-info">
                  {/* Title */}
                  <h4 className="s-30 w--700 xl:!text-[1.875rem] lg:max-xl:!text-[1.75rem] md:max-lg:!text-[1.764705rem] sm:max-md:!text-[1.81255rem] xsm:max-sm:!text-[1.5625rem] !font-bold xl:mt-[80px] mb--30 xl:!mb-[30px] lg:max-xl:!mt-[60px] lg:max-xl:!mb-[25px] md:max-lg:!mt-[40px] md:max-lg:!mb-[20px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      1.
                    </span>{' '}
                    Ownership
                  </h4>
                  {/* Text */}
                  <p>
                    Donec sodales nibh vel (the{' '}
                    <span className="text-[#353f4f] font-medium">
                      &quot;Terms&quot;
                    </span>
                    ) aliquet tristique purus justo suscipit mauris tempus sed
                    laoreet nulla ante purus. Donec dolor and magna undo
                    suscipit magna at tortor laoreet dignissim, undo porttitor
                    massa quisque and mollis, sapien gravida aliquet ipsum
                    ultrices aliquet lorem purus and vitae auris aliquam
                  </p>
                  {/* Text */}
                  <p>
                    Sagittis congue augue egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque
                    blandit fusce an aliquam nulla lacinia justo molestie
                    blandit justo diam aliquet tortor molestie non sagittis
                    lacinia
                  </p>
                  {/* Title */}
                  <h4 className="s-30 w--700 xl:!text-[1.875rem] lg:max-xl:!text-[1.75rem] md:max-lg:!text-[1.764705rem] sm:max-md:!text-[1.81255rem] xsm:max-sm:!text-[1.5625rem] !font-bold xl:mt-[80px] mb--30 xl:!mb-[30px] lg:max-xl:!mt-[60px] lg:max-xl:!mb-[25px] md:max-lg:!mt-[40px] md:max-lg:!mb-[20px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      2.
                    </span>{' '}
                    Acceptance of Terms
                  </h4>
                  {/* Text */}
                  <p>
                    Sagittis congue augue egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque
                    blandit fusce lacinia placerat and nulla justo molestie
                    blandit justo diam aliquet tortor molestie sagittis lacinia
                    undo and mullam molestie diam luctus donec bibendum aliquet
                    massa elementum. Libero quisque lacus and ligula massa lorem
                    fusce cursus fusce nulla vitae massa placerat and mollis,
                    sapien gravida aliquet ipsum ultrices aliquet lorem diam
                    purus undo vitae aliquam auris dapibus libero fusce blandit.
                  </p>
                  {/* Text */}
                  <p>
                    Congue augue sagittis egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque
                    blandit fusce lorem nulla an aliquam lacinia justo molestie
                    blandit justo diam an aliquet tortor sagittis lacinia
                    molestie diam egestas
                  </p>
                  {/* Title */}
                  <h4 className="s-30 w--700 xl:!text-[1.875rem] lg:max-xl:!text-[1.75rem] md:max-lg:!text-[1.764705rem] sm:max-md:!text-[1.81255rem] xsm:max-sm:!text-[1.5625rem] !font-bold xl:mt-[80px] mb--30 xl:!mb-[30px] lg:max-xl:!mt-[60px] lg:max-xl:!mb-[25px] md:max-lg:!mt-[40px] md:max-lg:!mb-[20px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      3.
                    </span>{' '}
                    Service Description
                  </h4>
                  {/* Text */}
                  <p>
                    Congue sagittis augue egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque
                    blandit fusce aliquam
                  </p>
                  {/* List */}
                  <ul className="simple-list">
                    <li className="list-item">
                      <p>
                        Quaerat sodales sapien undo velna purus euismod purus
                        velna blandit vitae auctor and congue magna tempor
                        sapien gravida laoreet turpis urna augue, viverra a
                        augue eget diam pulvinar
                      </p>
                    </li>
                    <li className="list-item">
                      <p>
                        Nemo ipsam egestas volute turpis dolores ut aliquam
                        quaerat sodales sapien congue and augue egestas
                      </p>
                    </li>
                  </ul>
                  {/* Small Title */}
                  <h5 className="s-24 w--700 xl:!text-[1.5rem] lg:max-xl:!text-[1.375rem] md:max-lg:!text-[1.470588rem] sm:max-md:!text-[1.625rem] xsm:max-sm:!text-[1.4375rem] !font-bold leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4] xl:!mb-[20px] lg:max-xl:!mb-[18px] md:max-lg:!mb-[18px] sm:max-md:!mb-[18px]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      3.1.
                    </span>{' '}
                    Subscription
                  </h5>
                  {/* Text */}
                  <p>
                    Integer congue sagittis augue egestas velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque diam
                    augue fusce sapien nulla a primis lacinia ipsum a molestie
                    blandit and justo an aliquet eget molestie sagittis at
                    quaerat sodales
                  </p>
                  {/* Text */}
                  <p>
                    Aliqum mullam tincidunt a sapien gravida and diam donec
                    porta.
                  </p>
                  {/* Title */}
                  <h4 className="s-30 w--700 xl:!text-[1.875rem] lg:max-xl:!text-[1.75rem] md:max-lg:!text-[1.764705rem] sm:max-md:!text-[1.81255rem] xsm:max-sm:!text-[1.5625rem] !font-bold xl:mt-[80px] mb--30 xl:!mb-[30px] lg:max-xl:!mt-[60px] lg:max-xl:!mb-[25px] md:max-lg:!mt-[40px] md:max-lg:!mb-[20px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      4.
                    </span>{' '}
                    Account Information
                  </h4>
                  {/* Text */}
                  <p>
                    Sagittis congue augue egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque
                    blandit fusce lacinia placerat and nulla justo molestie
                    blandit justo diam aliquet tortor molestie sagittis lacinia
                    undo and mullam molestie diam luctus donec bibendum aliquet
                    massa elementum. Libero quisque lacus and ligula massa
                    lorem.
                  </p>
                  {/* Small Title */}
                  <h5 className="s-24 w--700 xl:!text-[1.5rem] lg:max-xl:!text-[1.375rem] md:max-lg:!text-[1.470588rem] sm:max-md:!text-[1.625rem] xsm:max-sm:!text-[1.4375rem] !font-bold leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4] xl:!mb-[20px] lg:max-xl:!mb-[18px] md:max-lg:!mb-[18px] sm:max-md:!mb-[18px]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      4.1.
                    </span>{' '}
                    Registering for an account
                  </h5>
                  {/* Text */}
                  <p>
                    Congue augue sagittis egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque
                    blandit fusce lorem nulla an aliquam lacinia justo molestie
                    blandit justo diam an aliquet tortor sagittis lacinia
                    molestie diam egestas
                  </p>
                  {/* Text */}
                  <p>
                    Sagittis augue congue egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque
                    aliquam fusce blandit
                  </p>
                  {/* Small Title */}
                  <h5 className="s-24 w--700 xl:!text-[1.5rem] lg:max-xl:!text-[1.375rem] md:max-lg:!text-[1.470588rem] sm:max-md:!text-[1.625rem] xsm:max-sm:!text-[1.4375rem] !font-bold leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4] xl:!mb-[20px] lg:max-xl:!mb-[18px] md:max-lg:!mb-[18px] sm:max-md:!mb-[18px]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      4.2.
                    </span>{' '}
                    Your responsibility for your account
                  </h5>
                  {/* Text */}
                  <p>
                    Integer congue sagittis augue egestas velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque diam
                    augue fusce sapien
                  </p>
                  {/* Title */}
                  <h4 className="s-30 w--700 xl:!text-[1.875rem] lg:max-xl:!text-[1.75rem] md:max-lg:!text-[1.764705rem] sm:max-md:!text-[1.81255rem] xsm:max-sm:!text-[1.5625rem] !font-bold xl:mt-[80px] mb--30 xl:!mb-[30px] lg:max-xl:!mt-[60px] lg:max-xl:!mb-[25px] md:max-lg:!mt-[40px] md:max-lg:!mb-[20px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      5.
                    </span>{' '}
                    Price and Taxes
                  </h4>
                  {/* List */}
                  <ul className="simple-list">
                    <li className="list-item">
                      <p>
                        Quaerat sodales sapien undo velna purus euismod purus
                        velna blandit vitae auctor and congue magna tempor
                        sapien gravida laoreet turpis urna augue, viverra a
                        augue eget tempor diam
                      </p>
                    </li>
                    <li className="list-item">
                      <p>
                        Nemo ipsam egestas volute turpis dolores ut aliquam
                        quaerat sodales sapien congue and augue egestas
                      </p>
                    </li>
                  </ul>
                  {/* Text */}
                  <p>
                    Augue congue sagittis egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque donec
                    and ipsum porta diam lorem sodales an aliquam lacinia justo
                    sapien congue aliquet and sodales a quaerat tortor lacinia
                    egestas
                  </p>
                  {/* Title */}
                  <h4 className="s-30 w--700 xl:!text-[1.875rem] lg:max-xl:!text-[1.75rem] md:max-lg:!text-[1.764705rem] sm:max-md:!text-[1.81255rem] xsm:max-sm:!text-[1.5625rem] !font-bold xl:mt-[80px] mb--30 xl:!mb-[30px] lg:max-xl:!mt-[60px] lg:max-xl:!mb-[25px] md:max-lg:!mt-[40px] md:max-lg:!mb-[20px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      6.
                    </span>{' '}
                    Method of Payment
                  </h4>
                  {/* Text */}
                  <p>
                    Integer congue sagittis augue egestas velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque diam
                    augue fusce sapien
                  </p>
                  {/* Text */}
                  <p>
                    Sagittis augue congue egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec and
                    augue luctus congue
                  </p>
                  {/* Small Title */}
                  <h5 className="s-24 w--700 xl:!text-[1.5rem] lg:max-xl:!text-[1.375rem] md:max-lg:!text-[1.470588rem] sm:max-md:!text-[1.625rem] xsm:max-sm:!text-[1.4375rem] !font-bold leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4] xl:!mb-[20px] lg:max-xl:!mb-[18px] md:max-lg:!mb-[18px] sm:max-md:!mb-[18px]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      6.1.
                    </span>{' '}
                    Refunds
                  </h5>
                  {/* Text */}
                  <p>
                    Integer congue sagittis augue egestas velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque diam
                    augue fusce sapien nulla a primis lacinia ipsum a molestie
                    blandit and justo an aliquet eget molestie sagittis at
                    quaerat sodales
                  </p>
                  {/* Text */}
                  <p>
                    Aliqum mullam tincidunt a sapien gravida and diam donec
                    porta.
                  </p>
                  {/* Title */}
                  <h4 className="s-30 w--700 xl:!text-[1.875rem] lg:max-xl:!text-[1.75rem] md:max-lg:!text-[1.764705rem] sm:max-md:!text-[1.81255rem] xsm:max-sm:!text-[1.5625rem] !font-bold xl:mt-[80px] mb--30 xl:!mb-[30px] lg:max-xl:!mt-[60px] lg:max-xl:!mb-[25px] md:max-lg:!mt-[40px] md:max-lg:!mb-[20px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      7.
                    </span>{' '}
                    Security
                  </h4>
                  {/* Text */}
                  <p>
                    Sagittis congue augue egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque
                    blandit fusce lacinia placerat and nulla justo molestie
                    blandit justo diam aliquet tortor molestie sagittis lacinia
                    undo and mullam molestie diam luctus donec bibendum aliquet
                    massa elementum. Libero quisque lacus and ligula massa lorem
                    fusce cursus fusce nulla vitae massa placerat and mollis,
                    sapien gravida aliquet ipsum ultrices aliquet lorem diam
                    purus undo vitae aliquam auris dapibus libero fusce blandit.
                  </p>
                  {/* Title */}
                  <h4 className="s-30 w--700 xl:!text-[1.875rem] lg:max-xl:!text-[1.75rem] md:max-lg:!text-[1.764705rem] sm:max-md:!text-[1.81255rem] xsm:max-sm:!text-[1.5625rem] !font-bold xl:mt-[80px] mb--30 xl:!mb-[30px] lg:max-xl:!mt-[60px] lg:max-xl:!mb-[25px] md:max-lg:!mt-[40px] md:max-lg:!mb-[20px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      8.
                    </span>{' '}
                    Changes to This Terms of Service
                  </h4>
                  {/* Text */}
                  <p>
                    Congue augue sagittis egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque
                    blandit fusce lorem nulla an aliquam lacinia justo molestie
                    blandit justo diam an aliquet tortor sagittis lacinia
                    molestie diam egestas
                  </p>
                  {/* Text */}
                  <p>
                    Sagittis augue congue egestas integer velna purus purus
                    magna nec suscipit and egestas magna aliquam ipsum vitae
                    purus justo lacus ligula ipsum primis cubilia donec undo
                    augue luctus vitae egestas a molestie donec libero sapien
                    dapibus congue tempor undo quisque fusce cursus neque
                    aliquam fusce blandit
                  </p>
                  {/* Title */}
                  <h4 className="s-30 w--700 xl:!text-[1.875rem] lg:max-xl:!text-[1.75rem] md:max-lg:!text-[1.764705rem] sm:max-md:!text-[1.81255rem] xsm:max-sm:!text-[1.5625rem] !font-bold xl:mt-[80px] mb--30 xl:!mb-[30px] lg:max-xl:!mt-[60px] lg:max-xl:!mb-[25px] md:max-lg:!mt-[40px] md:max-lg:!mb-[20px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    <span className="mr-[4px] lg:max-xl:mr-[2px] md:max-lg:mr-[2px]">
                      9.
                    </span>{' '}
                    How to Contact Us
                  </h4>
                  {/* Text */}
                  <p>
                    If you have any questions or suggestions about this Terms of
                    Service, do not hesitate to contact us at{' '}
                    <a
                      href="mailto:yourdomain@mail.com"
                      className="color--theme font-medium !underline hover:text-[#353f4f] hover:!underline"
                    >
                      hello@yourdomain.com
                    </a>
                  </p>
                </div>
                {/* END TEXT BLOCK */}
              </div>
            </div>
            {/* End row */}
          </div>
          {/* End container */}
        </section>
        {/* END TERMS PAGE */}
      </main>
      <Footer />
    </div>
  );
};

export default TermsPage;
